import { 
	createSlice,
	createAsyncThunk
} from '@reduxjs/toolkit'
import {envAwareFormSubmit,envAwarePost} from '../../util/util'


export const createProgressPicture = createAsyncThunk(
	'createProgressPicture',
	async payload => envAwarePost('api/pictures/',{
		action:'createProgressPicture',
		...payload
	})
)

export const deletePicture = createAsyncThunk(
	'deletePicture',
	async id => envAwarePost('api/pictures/',{
		action: "deleteProgressPicture",
		id
	})
)

export const getPicturesByDate = createAsyncThunk(
	'getPicturesByDate',
	async client_id => envAwarePost('api/pictures/',{
		action:'fetchProgressPicturesByDate',
		client_id
	})
)

const photoRealSlice = createSlice({
	name: 'photoReel',
	initialState:{picsByDate:[], newPic: {}},
	reducers: {},
	extraReducers:{
		[getPicturesByDate.fulfilled] : (state,action)=>{
			console.log('ACTION: ', action)
			const {success,data} = action.payload
			if(success == 1){
				state.picsByDate  = data.pics
			} else {
				state.picsByDate = []
			}
		},
		[createProgressPicture.fulfilled] : (state,action)=>{
			const {success,data} = action.payload
			if (success == 1) {
				state.newPic = action.payload.data.pic
			}
		},
		[deletePicture.fulfilled] : (state, action) => {
			console.log(action.meta.arg,"arg");
			state.picsByDate = state.picsByDate.map(picsGroup =>  ({...picsGroup, pictures: picsGroup.pictures.filter(pic => pic.pic_id != action.meta.arg)}))
		}
	}
})


export default photoRealSlice.reducer